<div *ngIf="loading" class="preloader">
    <div class="loader">
        <div class="loader__figure"></div> 
    </div>
</div>